import styled, { css } from 'styled-components'

interface ITileFormSpanWithDataProps {
  legend?: string
}

export const TileFormSpanWithData = styled.span<ITileFormSpanWithDataProps>(
  ({
    theme, legend,
  }) => {
    const {
      palette, typography,
    } = theme
    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${palette.dark.normal};
      margin: 0.5rem 0;

      > * {
        margin-right: 0.375rem;
      }

      > span:nth-child(1) {
        font-size: ${typography.small.pt_13_regular.fontSize};
        font-weight: ${typography.small.pt_13_regular.fontWeight};
        line-height: ${typography.small.pt_13_regular.lineHeight};
      }

      > span:nth-child(2) {
        font-size: ${typography.small.pt_14_semibold.fontSize};
        font-weight: ${typography.small.pt_14_semibold.fontWeight};
        line-height: ${typography.small.pt_14_semibold.lineHeight};
      }

      ${legend
      && css`
        border-left: 10px solid ${legend};
        padding-left: 10px;
      `}
    `
  },
)
